import * as Yup from 'yup';

const LoyaltyCodeSchema = Yup.object().shape({
  loyaltyCode: Yup.string()
    .trim('Please enter your loyalty code')
    .required('Please enter your loyalty code'),
});

export default LoyaltyCodeSchema;
